import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { DataQuery } from '../../models/data-query.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { YearService } from '../../../../shared-components/year/year.service';
import { UserService } from '../../../../shared-components/user/user.service';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';

@AutoUnsubscribe()
@Component({
    selector: 'app-templated-from-class-dialog',
    templateUrl: './templates-from-classic-dialog.component.html',
    styleUrls: ['./templates-from-classic-dialog.component.css']
})
export class TemplatesFromClassicDialogComponent implements OnInit, OnDestroy {

    // Injected Properties
    legacyQueries: DataQuery[] = [];

    // Properties
    tableData = new TylerMatTableDataSource();
    columns = ['Name', 'Description', 'Scope', 'Owner'];

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<TemplatesFromClassicDialogComponent>,
        private loginService: LoginService,
        private yearService: YearService,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) { }

    @ViewChild(MatPaginator, { static: true }) set paginator(value: MatPaginator) {
        this.tableData.paginator = value;
    }

    // Event Functions
    ngOnInit() {
        // POST: performs initialization

        // Obtaining the legacy queries
        this.legacyQueries = this.data.legacyQueries;
        this.tableData.data = this.legacyQueries;

        // Setting which columns to display
        if (this.loginService.LoginSettings.V10) {
            this.columns.splice(this.columns.indexOf('Scope'), 1);
            this.columns.splice(this.columns.indexOf('Owner'), 1);
        } else {
            this.columns.splice(this.columns.indexOf('Description'), 1);
        }
    }

    ngOnDestroy() {
        // NOTE: implemented for @AutoUnsubscribe
    }

    close() {
        // PRE: the close button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }

    queryClick(query: DataQuery) {
        // PRE: a data query row is clicked
        // PST: sets the imported query to the legacy query
        const returnQuery = Object.assign(new DataQuery(), query);
        if (!this.loginService.LoginSettings.V10 && query.Scope != 'Private' && query.Scope != 'District') {
            query.Scope = 'Selected Sites';

            const querySchool = this.yearService.years.find(school => school.SchoolCode == query.SelectedSites);
            if (querySchool) {
                returnQuery.SelectedSites = querySchool.Id.toString();
            }
            this.dialogBox.close(returnQuery);
        } else {
            this.dialogBox.close(returnQuery);
        }
    }

    // Methods

}
